import UsuariosRoute from '@/modules/app/usuarios/routes'
import MenusRoute from '@/modules/app/menus/routes'
// import RotasRoute from '@/modules/app/rotas/routes'
// import ModulosRoute from '@/modules/app/modulos/routes'
// import GruposRoute from '@/modules/app/grupos/routes'
// import GrupoRotaRoute from '@/modules/app/grupo-rotas/routes'
import UsuarioPerfilRoute from '@/modules/app/usuarios-perfis/routes'
import PerfilMenuRoute from '@/modules/app/perfis-menus/routes'
import ModulosRoute from '@/modules/app/ctrl-modulos/routes'
// import PerfilRotaRoute from '@/modules/app/perfis-rotas/routes'
// import PerfilUsuarioRoute from '@/modules/app/perfis-usuarios/routes'
// import SubModulosRoute from '@/modules/app/submodulos/routes'
import PerfilRoute from '@/modules/app/perfis/routes'
import CtrlEquipesRoute from '@/modules/app/ctrl-equipes/routes'
// import HomeAppRoute from '@/modules/app/homepage/routes'
// import VueComponenteMenuRoute from '@/modules/app/vue-componentes-menus/routes'
// import UsuarioApiRoute from '@/modules/app/usuarios-apis/routes'
// import AutenticacaoRoute from '@/modules/app/acl-autenticacoes/routes'
const routes = [
  ...UsuariosRoute,
  ...MenusRoute,
  // ...RotasRoute,
  // ...ModulosRoute,
  // ...GruposRoute,
  // ...GrupoRotaRoute,
  ...UsuarioPerfilRoute,
  ...PerfilMenuRoute,
  // ...PerfilRotaRoute,
  // ...PerfilUsuarioRoute,
  // ...SubModulosRoute,
  ...PerfilRoute,
  ...CtrlEquipesRoute,
  // ...HomeAppRoute,
  // ...VueComponenteMenuRoute,
  // ...UsuarioApiRoute,
  // ...AutenticacaoRoute
  ...ModulosRoute,
]

export default routes